import React from "react";
import "./Footer.css";
import WhiteBlock from "../WhiteBlock/WhiteBlock.js";
import Map from "../Map/Map.js";

const Footer = () =>{
    return(
        <footer className="footer">
             <WhiteBlock positiont="tr"/>
            <div className="footer-box">
                <div className="box-text">
                    <h3>Jak do nas trafić</h3>
                    <br/>
                    <p>Dojazd jest naprawdę wygodny. Lubawa usytuowana jest przy drodze krajowej nr 15 na trasie Olsztyn-Toruń. <br/>Jest to jedna z głównych dróg wiodących z zachodnich rejonów Polski na Mazury, można do nas wpaść po drodze i przy okazji.<br/> Można podjechać samochodem pod siedzibę OSIR przy ul. Łąkowej 8 w sąsiedztwie parku linowego,<br/> lub do samego parku linowego znajdującego się w lubawskich Łazienkach od strony ulicy Kupnera.</p>
                </div>
                <div className="box-map">
                <Map/>
                </div>
            </div>
            <hr/>
            <div className="footer-bottom">
                    <p>Wszystkich informacji udziela Recepcja OSiR pod nr tel. (89) 645 24 18, email: recepcja@osir.lubawa.pl</p>
            </div>
        </footer>
    )
}

export default Footer;